import styled, { css } from 'styled-components';

export const Container = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: 3.2rem;
    padding:1rem 0.75rem 1rem 1rem;
    align-items: center;
    border-radius: 10px;
    background-color:${({ theme }) => theme.colors.__white};
    opacity: 1;
    margin-right:1rem;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05), 0 0px 40px rgba(0, 0, 0, 0.08);

    &:focus-within {
        label {
            top: -1.2rem;
            font-size: 16px;
            color:${({ theme }) => theme.colors.__gray[700]};
        }
    }

    @media (max-width:400px){
        padding:0.0rem;

    }

    label{

        position: absolute;
        display: block;
        top: 50%;
        left: 1rem;
        pointer-events: none;

        transform: translateY(-50%);
        transition: all 200ms ease-in-out;

        font-size: 16px;
        font-weight: normal;
        color:${({ theme }) => theme.colors.__gray[700]};
        background-color: transparent;
    }

    input {
        display: flex;
        outline: none;
        border: 0px;
        width: 100%;    
        height: 100%;
        font-size: 14px;
        font-weight: normal;
        color:${({ theme }) => theme.colors.__gray[750]};
        background-color: transparent;
        text-indent: 0.2rem;  
        padding-right:0.2rem;
    }

    input:not([value='']) {
        + label {
            top: -1.2rem;
            font-size: 16px;
            color:${({ theme }) => theme.colors.__blue[500]};
        }
    }

    span{
        height: 100%;
        min-width: 2rem;
        margin-left: 0.3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color:${({ theme }) => theme.colors.__blue[550]};
    }

    ${({ disable }) => disable &&
        css`
            pointer-events:none;
            opacity: 0.8;
        `
    };


`;
